import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ResponseSearchComponentState, StateName } from './response-search.state';

export const selectedResponseSearchCtx = createFeatureSelector<ResponseSearchComponentState>(StateName);

// export const selectResponseSearchText = createSelector(selectedResponseSearchCtx,
//   (state: ResponseSearchComponentState, props: { componentId: string}) => {
//     const key = props.componentId;
//     return state.searchTexts[key];
//   }
// );

// Refactored version using memomized selectors
export const selectResponseSearchText = (properties: { componentId: string }) => createSelector(selectedResponseSearchCtx,
  (state: ResponseSearchComponentState) => state.searchTexts[properties.componentId]);
